export default "__VITE_ASSET__CJ6JO958__"